import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';

import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { RenderIf } from '../../utils/RenderIf';

import ErrorAlert from '../../Alerts/ErrorAlert';
import { Badge } from 'react-bootstrap';
import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';

import { ListGroup } from 'react-bootstrap';
import { ItemsFechtAPI } from '../../../api/Items';
import { SegmentsFechtAPI } from '../../../api/Segments';
import { TaxesFetchAPI } from '../../../api/Taxes';

import Select from 'react-select';

function ModalAddSegmentToitem({ item, load}) {
    const [showModal, setShowModal] = useState(false)
    const [eventHandle, setEventHandle] = useState(0);
    const [taxes, setTaxes] = useState([])
    const [segmentSelectNow, setSegmentSelectNow] = useState('')
    const [segmentsSelect, setSegmentsSelect] = useState([]);
    const [taxesSelect, setTaxesSelect] = useState([])
    const [tax_id, setTax_id] = useState('')
    const [price, setPrice] = useState('')
    let token = localStorage.getItem("x-access-token")
    let user = localStorage.getItem('user');

    const getTaxes = async () => {
        try {
            const response = await TaxesFetchAPI.getTaxes(token);
            setTaxes(response.data.data)

        } catch (err) {
            console.log(err);
        }
    }

    const asingProductToSegment = async () => {
        let data = {
            price: price,
            taxes: taxesSelect,
        }

        console.log(data);
        try {
            const response = await SegmentsFechtAPI.asingItemsToSegment(item.item_id, segmentSelectNow, data, token)
            setTaxesSelect([])
            load()
            setShowModal(false)
            ErrorAlert('', 'Item asignado correctamente', 'success')

        } catch (err) {
            console.log(err)
            ErrorAlert('', 'Error de asignacion', 'error')
        }
    }

      //filter checkbox in state true and save in state array
      const getChecked = (event) => {
        let dataTaxes = JSON.parse(event.target.value)


        if (event.target.checked == true) {
            setTaxesSelect([...taxesSelect, dataTaxes])
        } else if (event.target.checked == false) {
            for (let i = 0; i < taxesSelect.length; i++) {
                if (taxesSelect[i] == dataTaxes) {
                    taxesSelect.splice(i, 1)
                }
            }
        }
    }


    const getSegmentByBusiness = async () => {
        user = JSON.parse(localStorage.getItem('user'))
        try {
            const response = await SegmentsFechtAPI.getSegmentByBusiness(user.business_id, token)

            
            let segmentInfo = []
            response.data.data.forEach(segment => {
                segmentInfo.push({ value: segment.segment_id, label: segment.name }) 
            });

            setSegmentsSelect(segmentInfo)
        } catch (err) {
            console.log(err);
        }
    }

    const handleSaveTableSelect = (option) =>{
        setSegmentSelectNow(option.value);
     }

    useEffect(() => {

    }, [eventHandle])

    return (
        <>
            <button className='btn btn-primary btn-sm border-0 m-2' onClick={() => (setShowModal(true), getTaxes(), getSegmentByBusiness())}>
                <i className="uil uil-plus">Agregar a un acompañante</i>
            </button>


            {/*Add item segment*/}
            <Modal
                show={showModal}
                onHide={() => (setShowModal(false))}
                size='large'
                centered>
                <Modal.Header>
                    <h3><i className="uil uil-plus"></i>Asignar producto individual a un acompañante</h3>
                </Modal.Header>
                <Modal.Body>
                    <Form
                        className="needs-validation"

                    >

                        <Form.Group className="mb-3" controlId="clientId">
                            <Form.Label>Acompañante</Form.Label>
                        

                            <Select
                                className='w-100'
                                options={segmentsSelect}
                                onChange={handleSaveTableSelect}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="name">
                            <Form.Label>Precio</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="$0.00"
                                onChange={(e) => setPrice(e.target.value)}
                            />
                        </Form.Group>

                    

                        <Form.Group className="mb-3" >
                            <Form.Label>Impuestos </Form.Label>
                            <div>
                                {taxes.map((tax, index) => (
                                    <>
                                        <Form.Check
                                            inline
                                            label={tax.tax}
                                            name="taxes"
                                            type='checkbox'
                                            value={JSON.stringify(tax.id)}
                                            onChange={(e) => getChecked(e)}
                                            id={`tax${tax.id}`}
                                        />
                                    </>
                                ))}
                            </div>
                        </Form.Group>

                        <div className="mt-3 d-flex justify-content-end">
                            <Button size="sm" variant="success" type="button" className='m-3' onClick={() => asingProductToSegment()} >
                                Guardar
                            </Button>
                        </div>
                    </Form>


                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => (setShowModal(false))}>Cerrar</Button>
                </Modal.Footer>
            </Modal>




        </>
    )
}

export default ModalAddSegmentToitem